import styles from "../HealthChat.module.css";

const CONDITIONS_MAP = {
  period: [
    "Polycystic Ovary Syndrome (PCOS)",
    "Endometriosis",
    "Uterine Fibroids",
  ],
  pregnancy: [
    "Ectopic Pregnancy Risk",
    "Hyperemesis Gravidarum",
    "Gestational Diabetes",
  ],
  vaginal: ["Bacterial Vaginosis", "Vaginal Atrophy", "Yeast Infection"],
  pelvic: ["Pelvic Inflammatory Disease", "Ovarian Cyst", "Appendicitis"],
  lumps: ["Fibrocystic Breast Changes", "Lymph Node Swelling", "Lipoma"],
  mood: [
    "Premenstrual Dysphoric Disorder",
    "Perimenopause",
    "Anxiety Disorder",
  ],
  discharge: [
    "Bacterial Vaginosis",
    "Cervical Infection",
    "Normal Hormonal Discharge",
  ],
  fatigue: [
    "Iron Deficiency Anemia",
    "Thyroid Dysfunction",
    "Chronic Fatigue Syndrome",
  ],
  headache: ["Tension Headache", "Migraine", "Hormonal Headache"],
  other: [
    "General Health Issue",
    "Stress-Related Condition",
    "Nutritional Deficiency",
  ],
};

const DESC_MAP = {
  period: [
    "Hormonal imbalance affecting ovulation and menstrual cycles.",
    "Tissue similar to uterine lining grows outside the uterus.",
    "Non-cancerous growths in the uterus causing heavy bleeding.",
  ],
  pregnancy: [
    "Fertilized egg implants outside the uterus — urgent care needed.",
    "Severe nausea and vomiting during pregnancy.",
    "High blood sugar during pregnancy requiring monitoring.",
  ],
  vaginal: [
    "Imbalance of bacteria in the vagina.",
    "Thinning of vaginal walls due to lower estrogen.",
    "Fungal infection causing itching and discharge.",
  ],
  pelvic: [
    "Infection of the female reproductive organs.",
    "Fluid-filled sac on or in the ovary.",
    "Inflammation of the appendix requiring urgent care.",
  ],
  lumps: [
    "Noncancerous fibrous tissue changes in the breast.",
    "Swollen nodes near an infection site.",
    "Benign fatty lump under the skin.",
  ],
  mood: [
    "Severe PMS symptoms affecting daily function.",
    "Hormonal transition before menopause.",
    "Persistent worry or panic affecting daily life.",
  ],
  discharge: [
    "Overgrowth of harmful bacteria in the vagina.",
    "Sexually transmitted infection affecting the cervix.",
    "Discharge caused by normal hormonal fluctuations.",
  ],
  fatigue: [
    "Low iron levels reducing oxygen in blood.",
    "Underactive or overactive thyroid gland.",
    "Persistent fatigue not resolved by rest.",
  ],
  headache: [
    "Muscle-tension headache from stress or posture.",
    "Recurring severe headache often with nausea.",
    "Headaches triggered by hormonal fluctuations.",
  ],
  other: [
    "General health concern requiring professional assessment.",
    "Physical symptoms arising from mental stress.",
    "Imbalance in vitamins or minerals.",
  ],
};

export default function TriageResultsScreen({
  symptomCat,
  onSeekHelp,
  onNext,onBack
}) {
  const catId = symptomCat?.id || "other";
  const conditions = CONDITIONS_MAP[catId] || CONDITIONS_MAP.other;
  const descs = DESC_MAP[catId] || DESC_MAP.other;

  return (
    <div className={styles.triageResultsScreen}>
      <button className={styles.selectDoctorBack} onClick={onBack}>
        ← Back
      </button>
      <div className={styles.triageResultsTitle}>Triage Results</div>

      {/* Risk card */}
      <div className={styles.triageRiskCard}>
        <div className={styles.triageRiskIcon}>⚠️</div>
        <div>
          <div className={`ava-text-body ava-font-semibold `}>Moderate Risk</div>
          <div className={`ava-text-body ${styles.triageRiskDesc}`}>
            Your symptoms suggest a moderate risk condition. It's important to get medical evaluation soon.
          </div>
        </div>
      </div>

      {/* Possible conditions */}
      <div className={styles.triageConditionsTitle}>Possible Conditions</div>
      <div className={styles.triageConditionsNote}>
        These are not diagnoses, but potential conditions based on your
        symptoms.
      </div>

      {conditions.map((cond, i) => (
        <div key={i} className={styles.triageConditionRow}>
          <span className={styles.triageConditionDot}>⚠️</span>
          <div>
            <div className={styles.triageConditionName}>{cond}</div>
            <div className={styles.triageConditionDesc}>{descs[i]}</div>
          </div>
        </div>
      ))}

      <div className={styles.triageDisclaimer}>
        Please seek medical attention to get an accurate diagnosis and
        appropriate treatment.
      </div>

      <button className={styles.triageSeekBtn} onClick={onNext || onSeekHelp}>
        Seek Medical Attention
      </button>
    </div>
  );
}
